/**
 * StatisticDaily
 * --
 */
import React from 'react';
import { Input, Space, Table, Button } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { Content, Title, Row, Col } from 'components';
import moment from 'moment';
import MessageAlert, { stringToMoneyFormat } from 'utils';
import { downloadXlsx } from 'utils/XlsxDownloader';
/* 
사용중인 필드
{
    "menu_id": "1",
    "menu_name": "콜드브루 라뗴",
    "option": "HOT/ICE",
    "option_name": "샷 추가", - 명
    "option_price": "100", - 단가
    "total_option_count": "4", - 총수량
    "total_option_price": "400" - 총금액
}
*/
const SEARCH_KEYWORD = {
  menu_name: null,
};
/**----------------------------------------
 * [Component] 일자별 매출
 * ----------------------------------------
 */
const StatisticDaily = ({
  // shopList, // 업체목록
  // currentShop, // 선택된 업체 키
  data, // 차트 데이터
  startDate,
  endDate,
  onSelect,
  dateRange,
  // finalDiscount,
}) => {
  /* ===== ROUTE ===== */
  const [searchValue, setSearchValue] = React.useState(SEARCH_KEYWORD);
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  // const currentShopInfo = shopList.filter(({ key }) => key === currentShop)[0];
  /* ===== FUNCTION ===== */
  /**
   * 엑셀 다운로드
   * --
   */
  const handleDownloadExel = () => {
    try {
      const col = [
        {
          title: '메뉴아이디',
          dataIndex: 'menu_id',
        },
        {
          title: '메뉴명',
          dataIndex: 'menu_name',
        },
        ...optionCol(),
      ];
      downloadXlsx({
        columns: col,
        rows: newData2,
        fileName: '옵션별_매출',
      });
    } catch (e) {
      console.log(e);
      MessageAlert.error(e.message);
    }
  };

  /**
   * 데이터 바인팅
   * --
   * @param {string} t
   * @param {string | number} v
   */
  const handleChange = (t, v, menu_id) => {
    setSearchValue((prev) => {
      if (menu_id) {
        return {
          ...prev,
          [menu_id]: {
            ...prev[menu_id],
            [t]: v,
          },
        };
      } else {
        return {
          ...prev,
          [t]: v,
        };
      }
    });
  };

  /* ===== HOOKS ===== */

  /* ===== RENDER ===== */
  const col = [
    {
      title: '메뉴아이디',
      dataIndex: 'menu_id',
      width: 110,
      sorter: (a, b) => a.menu_id - b.menu_id,
      // fixed: 'left',
      // render: (v) => moment(v).format('YYYY-MM-DD(ddd)'),
    },
    {
      title: '메뉴명',
      dataIndex: 'menu_name',
      filterDropdown: ({ selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            value={searchValue?.menu_name}
            onChange={(e) => handleChange('menu_name', e.target.value)}
            onPressEnter={() => confirm()}
            placeholder={`메뉴명 검색`}
          />
          <Space style={{ marginTop: 8 }}>
            <Button
              type="primary"
              onClick={() => confirm()}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              검색
            </Button>
            <Button
              onClick={() => {
                handleChange('menu_name', null);
                clearFilters();
              }}
              size="small"
              style={{ width: 90 }}
            >
              초기화
            </Button>
          </Space>
        </div>
      ),
      // width: 240,
      // fixed: 'left',
      // render: (v) => moment(v).format('YYYY-MM-DD(ddd)'),
    },
  ];
  const optionCol = (menu_id) => [
    {
      title: '옵션명',
      dataIndex: 'option',
      width: 140,
      filterDropdown: ({ selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            value={searchValue[menu_id]?.option}
            onChange={(e) => handleChange('option', e.target.value, menu_id)}
            onPressEnter={() => confirm()}
            placeholder={`선택항목명 검색`}
          />
          <Space style={{ marginTop: 8 }}>
            <Button
              type="primary"
              onClick={() => confirm()}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              검색
            </Button>
            <Button
              onClick={() => {
                handleChange('option', null, menu_id);
                clearFilters();
              }}
              size="small"
              style={{ width: 90 }}
            >
              초기화
            </Button>
          </Space>
        </div>
      ),
    },
    {
      title: '선택항목명',
      dataIndex: 'option_name',
      width: 140,
      filterDropdown: ({ selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            value={searchValue[menu_id]?.option_name}
            onChange={(e) =>
              handleChange('option_name', e.target.value, menu_id)
            }
            onPressEnter={() => confirm()}
            placeholder={`선택항목명 검색`}
          />
          <Space style={{ marginTop: 8 }}>
            <Button
              type="primary"
              onClick={() => confirm()}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              검색
            </Button>
            <Button
              onClick={() => {
                handleChange('option_name', null, menu_id);
                clearFilters();
              }}
              size="small"
              style={{ width: 90 }}
            >
              초기화
            </Button>
          </Space>
        </div>
      ),
    },
    {
      title: '옵션타입',
      dataIndex: 'option_type',
      width: 90,
      render: (option_type) => <>{option_type}</>,
      filters: [
        {
          text: '수량옵션',
          value: 'COUNT',
        },
        {
          text: '선택옵션',
          value: 'CHOICE',
        },
      ],
      onFilter: (value, record) => record.option_type === value,
    },
    {
      title: '단가',
      dataIndex: 'option_price',
      width: 150,
      render: (v) => stringToMoneyFormat(Number(v)),
      sorter: (a, b) => a.option_price - b.option_price,
    },
    {
      title: '총 수량',
      dataIndex: 'total_option_count',
      width: 150,
      render: (v) => stringToMoneyFormat(Number(v)),
      sorter: (a, b) => a.total_option_count - b.total_option_count,
    },
    {
      title: '합계 금액',
      dataIndex: 'total_option_price',
      width: 150,
      render: (v) => stringToMoneyFormat(Number(v)),
      sorter: (a, b) => a.total_option_price - b.total_option_price,
    },
    // {
    //   title: '#',
    //   dataIndex: 'orders',
    //   width: 100,
    //   align: 'center',
    //   fixed: 'right',
    //   render: (orders) => (
    //     <Button
    //       size="small"
    //       onClick={() => {
    //         console.log('orders', orders);
    //         onSelect(orders);
    //       }}
    //     >
    //       상세보기
    //     </Button>
    //   ),
    // },
  ];

  /**
   * 데이터 정제
   * --
   */
  const result = {};
  data &&
    data.forEach((item) => {
      // menu_id로 그룹화
      if (!result[item.menu_id]) {
        result[item.menu_id] = {
          menu_name: item.menu_name,
          options: {},
        };
      }

      // option으로 그룹화
      if (!result[item.menu_id].options[item.option]) {
        result[item.menu_id].options[item.option] = [];
      }

      // option의 세부 사항 추가
      result[item.menu_id].options[item.option].push({
        option_name: item.option_name,
        option_type: item.option_type,
        total_option_count: item.total_option_count,
        option_price: item.option_price,
        total_option_price: item.total_option_price,
      });
    });

  /**
   * 검색 필터
   * --
   */
  const { newData, newData2 } = React.useMemo(() => {
    //메뉴
    let arr1 =
      Object.keys(result).map((item) => ({
        key: Number(item),
        menu_id: Number(item),
        ...result[item],
      })) ?? [];

    const { menu_name, ...rest } = searchValue;
    if (menu_name) {
      arr1 = arr1?.filter((item) => item?.menu_name?.includes(menu_name));
    }
    //옵션
    let arr2 = data
      ? data.map((item, i) => ({
          key: i,
          ...item,
          menu_id: Number(item.menu_id),
        }))
      : [];
    const entries = Object.entries(rest);
    if (entries.length) {
      arr2 = arr2.filter((item) => {
        const condition = rest?.[item.menu_id];
        if (!condition) return true; // 필터 없으면 통과

        const { option, option_name } = condition;

        if (option && !item.option?.includes(option)) return false;
        if (option_name && !item.option_name?.includes(option_name))
          return false;

        return true;
      });
    }
    return { newData: arr1, newData2: arr2 };
  }, [searchValue, result, data]);
  /*  */
  // const newData2 =

  return (
    <>
      <Content maxWidth={'100%'} padding={0} backgroundColor={'none'}>
        <Row>
          {/* === 상단 > 타이틀 === */}
          <Col x={12} style={{ display: 'flex', gap: 5 }}>
            <Title style={{ marginBottom: 7.5 }}>옵션별 리포트</Title>
            <Button onClick={() => handleDownloadExel()}>
              엑셀로 다운로드
            </Button>
          </Col>
          <Col x={12} style={{ textAlign: 'right' }}>
            <Title
              level={5}
              align="right"
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                marginBottom: 7.5,
              }}
            >
              <small>조회기간:</small>&nbsp;&nbsp;
              {!dateRange.startDate || !dateRange.endDate ? (
                <>
                  {moment(startDate).format('YYYY.MM.DD(ddd)')}~
                  {moment(endDate).format('YYYY.MM.DD(ddd)')}
                </>
              ) : (
                <>
                  {moment(dateRange.startDate).format('YYYY.MM.DD(ddd)')}~
                  {moment(dateRange.endDate).format('YYYY.MM.DD(ddd)')}
                </>
              )}
            </Title>
          </Col>
        </Row>

        {/* ===== 데이터 Header: end ===== */}
        {/* <br /> */}

        {/* ===== 데이터 테이블: start ===== */}
        <div style={{ overflow: 'auto', width: '100%', height: '100%' }}>
          <Table
            bordered
            size="small"
            className="boxShadow"
            pagination={{ pageSize: 45 }}
            style={{ minHeight: 580 }}
            scroll={{
              x: 'max-content',
            }}
            // dataSource={data ?? []}
            dataSource={newData}
            // onRow={(record) => {
            //   return {
            //     onClick: () => onSelect(record), // 행 클릭 시 이벤트 처리
            //   };
            // }}
            columns={col}
            expandable={{
              expandedRowRender: (rw) => {
                const options = newData2?.filter(
                  (item) => item.menu_id === rw.menu_id
                );
                return (
                  <Table
                    columns={optionCol(rw?.menu_id)}
                    // dataSource={result}
                    dataSource={options}
                    pagination={false}
                  />
                );
              },
              // defaultExpandedRowKeys: ['1', '2', '3'],
              // expandedRowKeys: newData2?.map((item) => item.menu_id),
            }}
          />
        </div>
        {/* ===== 데이터 테이블: end ===== */}
      </Content>
    </>
  );
};

StatisticDaily.defaultProps = {
  onSelect: () => {},
};
export default StatisticDaily;
